import useTypedContext from "hooks/useTypedContext";
import { VcsProvider } from "types/generated";
import Feedback from "ds/components/Feedback";
import { getDocsUrl } from "utils/getDocsUrl";

import StackSettingsFormWrapper from "../components/FormWrapper";
import StackSettingsPageLayout from "../components/PageLayout";
import StackSettingsSourceCodeEdit from "./Edit";
import StackSettingsSourceCodeView from "./View";
import { StackSettingsContextData } from "../Context";

const StackSettingsSourceCode = () => {
  const { stackSettings, canUpdateStack } = useTypedContext(StackSettingsContextData);
  const hasShowcaseProvider = stackSettings.provider === VcsProvider.Showcase;

  return (
    <StackSettingsPageLayout
      title="Source code"
      description={"Spacelift supports multiple VCS providers, both managed and self-hosted."}
      readMoreDocsLink={getDocsUrl("/concepts/stack/stack-settings#vcs-integration-and-repository")}
    >
      {canUpdateStack.result && hasShowcaseProvider && (
        <Feedback type="callout" variant="danger">
          Your stack is currently configured using the deprecated Showcase provider.
          <br /> Please use the new Source Code settings to configure your stack.
        </Feedback>
      )}

      <StackSettingsFormWrapper>
        {canUpdateStack.result ? <StackSettingsSourceCodeEdit /> : <StackSettingsSourceCodeView />}
      </StackSettingsFormWrapper>
    </StackSettingsPageLayout>
  );
};

export default StackSettingsSourceCode;
